import React, { useState } from 'react';
import './LandingPage.css';

const LandingPage = ({ navigateTo, playVideo }) => {
  const [activeTab, setActiveTab] = useState('latest');
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  // Sample video data
  const videos = [
    {
      id: 1,
      title: "Understanding Uniswap v4 Hooks in 60 Seconds",
      views: "12.4K",
      timestamp: "2 days ago",
      platform: "tiktok",
      url: "https://tiktok.com",
      description: "Quick explanation of Uniswap v4 hooks and how they revolutionize DeFi"
    },
    {
      id: 2,
      title: "How Unichain Changes Everything for DEX Liquidity",
      views: "8.7K",
      timestamp: "4 days ago",
      platform: "youtube",
      url: "https://youtube.com",
      description: "Deep dive into Unichain and its impact on DEX liquidity"
    },
    {
      id: 3,
      title: "Flash Loans on Uniswap v4 Explained",
      views: "15.2K",
      timestamp: "1 week ago",
      platform: "tiktok",
      url: "https://tiktok.com",
      description: "Flash loans made simple with real-world examples"
    },
    {
      id: 4,
      title: "Unichain vs Layer 2s: What's the Difference?",
      views: "10.1K",
      timestamp: "1 week ago",
      platform: "youtube",
      url: "https://youtube.com",
      description: "Comparing Unichain with other Layer 2 solutions"
    }
  ];

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setTimeout(() => {
        setSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  const handleVideoClick = (video) => {
    playVideo(video);
  };

  const filteredVideos = activeTab === 'latest' ? videos : videos.sort((a, b) => parseInt(b.views) - parseInt(a.views));

  return (
    <div className="app">
      {/* Header */}
      <header>
        <div className="container header-content">
          <h1 className="logo" onClick={() => navigateTo('home')} style={{cursor: 'pointer'}}>
            <span className="green">internet</span>
            <span className="purple">money</span>
            <span className="yellow">is</span>
            <span className="blue">serious</span>
            <span className="pink">.business</span>
          </h1>
          
          <nav className="main-nav">
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('home'); }} className="nav-link">Home</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('videos'); }} className="nav-link">Videos</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('learn'); }} className="nav-link">Learn</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }} className="nav-link">About</a>
          </nav>
          
          <button className="subscribe-btn" onClick={() => document.querySelector('.email-input').focus()}>
            Subscribe
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h2>DeFi Made Simple</h2>
          <p className="hero-text">
            Quick, easy-to-understand videos about Uniswap v4 and Unichain for busy traders and developers
          </p>
          <div className="cta-buttons">
            <a href="https://youtube.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer" className="cta-btn youtube">
              YouTube Shorts
            </a>
            <a href="https://tiktok.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer" className="cta-btn tiktok">
              TikTok
            </a>
          </div>
        </div>
      </section>

      {/* Video Gallery */}
      <section className="videos container">
        <div className="videos-header">
          <h3>Latest Content</h3>
          <div className="tab-buttons">
            <button 
              onClick={() => setActiveTab('latest')}
              className={`tab-btn ${activeTab === 'latest' ? 'active' : ''}`}
            >
              Latest
            </button>
            <button 
              onClick={() => setActiveTab('trending')}
              className={`tab-btn ${activeTab === 'trending' ? 'active' : ''}`}
            >
              Trending
            </button>
          </div>
        </div>

        <div className="video-grid">
          {filteredVideos.map(video => (
            <div key={video.id} className="video-card" onClick={() => handleVideoClick(video)} style={{cursor: 'pointer'}}>
              <div className="video-thumbnail">
                <div className="play-overlay">▶</div>
                <div className="platform-badge">
                  {video.platform === 'youtube' ? 'YouTube' : 'TikTok'}
                </div>
              </div>
              <div className="video-info">
                <h4 className="video-title">{video.title}</h4>
                <div className="video-meta">
                  <span>{video.views} views</span>
                  <span>{video.timestamp}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h3 className="section-title">Why Our Content Works</h3>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon quick">▶</div>
              <h4>Quick & Concise</h4>
              <p>All our videos are under 60 seconds, perfect for busy DeFi enthusiasts</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon jargon">💬</div>
              <h4>Jargon-Free</h4>
              <p>Complex DeFi concepts explained in simple terms anyone can understand</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon current">🔔</div>
              <h4>Always Current</h4>
              <p>Stay up-to-date with the latest Uniswap v4 and Unichain developments</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call To Action */}
      <section className="cta">
        <div className="container">
          <h3>Ready to Master DeFi?</h3>
          <p>Subscribe to get notified when new content drops</p>
          <form onSubmit={handleSubscribe} className="subscribe-form">
            <input 
              type="email" 
              placeholder="Enter your email" 
              className="email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="subscribe-cta">
              {subscribed ? 'Subscribed! ✓' : 'Subscribe Now'}
            </button>
          </form>
          {subscribed && (
            <p style={{color: 'green', marginTop: '10px'}}>
              Thanks for subscribing! We'll notify you when new content is available.
            </p>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h2 className="logo">
                <span className="green">internet</span>
                <span className="purple">money</span>
                <span className="yellow">is</span>
                <span className="blue">serious</span>
                <span className="pink">.business</span>
              </h2>
              <p>DeFi education in bite-sized videos</p>
            </div>
            
            <div className="footer-links">
              <a href="https://youtube.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer">YouTube</a>
              <a href="https://tiktok.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer">TikTok</a>
              <a href="https://twitter.com/imseriousbiz" target="_blank" rel="noopener noreferrer">Twitter</a>
              <a href="https://discord.gg/defi" target="_blank" rel="noopener noreferrer">Discord</a>
              <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }}>Contact</a>
            </div>
          </div>
          
          <div className="copyright">
            &copy; {new Date().getFullYear()} internetmoneyisserious.business | Not financial advice
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;